export default __webpack_public_path__ + "static/media/calendar.ed856302.svg";